import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { checkLogin } from "../../redux/actions/loginAuth/LoginAuth";

// admin sidebar to show on click of admin settings.
import AdminSettingsSideBar from "./AdminSettingsSideBar";
import AppraisalSettingsBar from "./AppraisalSettingBar"
// task sidebar to show on click of tasks.
import TaskSideBar from "./TaskSideBar";
// From index.
import { EmployeeSideBar, AdminSideBar } from "./index";

const user = JSON.parse(localStorage.getItem("user"))
  ? JSON.parse(localStorage.getItem("user"))
  : 0;

const role = user.RoleName;
// const role = "admin";
// const role = "developer";

const adminSettingPaths = [
  "/companylocation",
  "/department",
  "/designation",
  "/workprimise",
  "/employeetype",
  "/reward",
   "/companypolicy",
  "/rolesndpermission",
  "/assets",
  "/skills",
  "/skillcategory",
  "/certifications",
  "/technologies",

];
const appraisalSettingPaths=[
 
  "/potential",
  "/attribute",
  "/reviewrating",
  "/primarygoals",
  "/questionsforappraisee"
]
const empSettingsPaths = [
  "/emplist",
  "/assignRewards",
  "/processRewards",
];
const LeaveManagement =[
  "/calendaryear",
  "/leavetype",
  "/holidaycalender",
  "/shifts",
  "/assignleave",
  "/yearendprocess",
]
const configurationsPaths = [
  "/autolopconfig",
  "/timesheetautolockconfig",
  "/weeklytimesheetreminderconfig",
]
const projectsPaths = ["/listProjects", "/viewProject", "/taskboard"];
const leave=["/myleave"
  ,"/MyLeaveList"
,"/ApplyMyLeaves"
,"/MyLeaveAppliedList"
,"/MyDutyAppliedList"
,"/MyProcessLeaveList"
,"/HolidayCalendarList"
,"/LeaveCalendar"];
const taskPaths = ["/taskManagment"];
const payRoll = [
  "/employeeSalary",
  "/payRollItems",
  "/processSalary",
  "/salaryReport",
  "/plReport",
];
const finance = ["/pettyCash", "/giftVoucher", "/invoice"];
const helpdesk = [
  "/helpdesk",
  "/ticketDetails",
  "/ListAllTicktes",
  "/adminListAllTickets",
  "/taskSheetUnlockStatus"
];

const empAppraisal = ["/empAppraisal"];

function SideBar(props) {
  const { checkLogin } = props;
  const { loginUser, login } = props.loginUser;
  const pathname = props.location ? props.location.pathname : window.location.pathname;
  const [activeSideBar, setActiveSideBar] = useState(pathname); // take the path name then make that as then tab name.
  const [changedSideBar, setChangedSideBar] = useState(null);
  const [isOpenEmpDropDown, setIsOpenEmpDropDown] = useState(false);
  const [isOpenProjectsDropDown, setIsOpenProjectsDropDown] = useState(false);
  const [isOpenPayRroll, setIsOpenPayRoll] = useState(false);
  const [isOpenFinance, setIsOpenFinance] = useState(false);
  const [isOpenHelpdesk, setIsOpenHelpdesk] = useState(false);
  const [isOpenLeaveManagement, setIsOpenLeaveManagement] = useState(false);
  const [isOpenConfigurations, setIsOpenConfigurations] = useState(false);
  const [isOpenLeaveDropDown, setIsOpenLeaveDropDown] = useState(false);
  useEffect(() => {
    checkLogin();
  }, []);

  // Function ---------------------------
  const toggle = React.useCallback(
    (tab) => {
      if (activeSideBar !== tab) {
        setActiveSideBar(tab);
      }
    },
    [activeSideBar]
  );

  useEffect(() => {
    if (activeSideBar !== pathname) {
      setActiveSideBar(pathname);
    }
  }, [pathname, activeSideBar]);

  useEffect(() => {
    let sideBar = null;
    if (empSettingsPaths.includes(pathname)) {
      setIsOpenEmpDropDown(true);
      setChangedSideBar(null);
    } else if (projectsPaths.includes(pathname)) {
      setIsOpenProjectsDropDown(true);
      setChangedSideBar(null);
    }else if (leave.includes(pathname)) {
      setIsOpenLeaveDropDown(true);
      setChangedSideBar(null);
    } else if (payRoll.includes(pathname)) {
      setIsOpenPayRoll(true);
      setChangedSideBar(null);
    } else if (finance.includes(pathname)) {
      setIsOpenFinance(true);
      setChangedSideBar(null);
    } else if (helpdesk.includes(pathname)) {
      setIsOpenHelpdesk(true);
      setChangedSideBar(null);
    }
    else if (LeaveManagement.includes(pathname)) {
      setIsOpenLeaveManagement(true);
      setChangedSideBar(null);
    } else if (configurationsPaths.includes(pathname)) {
      setIsOpenConfigurations(true);
      setChangedSideBar(null);
    }
    adminSettingPaths.includes(pathname) &&
      (sideBar = (
        <AdminSettingsSideBar
          toggle={(toggleTab) => toggle(toggleTab)}
          activeTab={activeSideBar}
          loginUser={loginUser}
        />
      ));

      appraisalSettingPaths.includes(pathname) &&
      (sideBar = (
        <AppraisalSettingsBar
          toggle={(toggleTab) => toggle(toggleTab)}
          activeTab={activeSideBar}
          loginUser={loginUser}
        />
      ));

    taskPaths.includes(pathname) &&
      (sideBar = <TaskSideBar></TaskSideBar>);
    setChangedSideBar(sideBar);
  }, [activeSideBar, toggle, loginUser, pathname]);

  const handleAdminSettingClick = () => {
    props.history.push("/adminsettings");
  };

  // handle open project dropdown.
  const handleOpenProject = () => {
    setIsOpenProjectsDropDown((prevState) => !prevState);
  };
  const handleOpenLeave = () => {
    setIsOpenLeaveDropDown((prevState) => !prevState);
  };
  // handle open Employee settings dropdown.
  const handleOpenEmployeeSettings = () => {
    setIsOpenEmpDropDown((prevState) => !prevState);
  };
 const handleOpenLeaveManagement = () => {
  setIsOpenLeaveManagement((prevState) => !prevState);
};
 // handle open Configurations dropdown.
 const handleOpenConfigurations = () => {
  setIsOpenConfigurations((prevState) => !prevState);
};
  // handle open Helpdesk dropdown.
  const handleOpenHelpDesk = () => {
    setIsOpenHelpdesk((prevState) => !prevState);
  };

  // handle open Payroll dropdown.
  const handleOpenPayRoll = () => {
    setIsOpenPayRoll((prevState) => !prevState);
  };

  // handle open Finance dropdown.
  const handleOpenFinance = () => {
    setIsOpenFinance((prevState) => !prevState);
  };
  // handle open Finance dropdown.
  const handleHelpDesk = () => {
    setIsOpenHelpdesk((prevState) => !prevState);
  };
  return (
    <Fragment>
      <nav id="sidebar" className={props.sideBar ? "active" : ""}>
        <div className="sidebar-header text-center">
          <h3>
            {/* <i className="fas fa-2x fa-star-of-david"></i> */}
            <img
              src={require("../../img/sideBarLogoName1.png")}
              alt="no logo"
              style={{
                height: "auto",
                width: "85%",
                borderRadius: "8px  ",
              }}
            ></img>
          </h3>
          <strong>
            <img
              src={require("../../img/sideBarLogo.png")}
              alt="no logo"
              style={{
                height: "auto",
                width: "90%",
                borderRadius: "8px",
              }}
            ></img>
          </strong>
        </div>
        {changedSideBar === null ? (
          <Fragment>
            {loginUser !== null &&
              loginUser.RoleName === "Admin" &&
              changedSideBar === null && (
                <AdminSideBar
                  loginUser={loginUser}
                  activeSideBar={activeSideBar}
                  toggle={toggle}
                  handleProject={{
                    func: handleOpenProject,
                    state: isOpenProjectsDropDown,
                  }}
                  handleEmployeeSetting={{
                    func: handleOpenEmployeeSettings,
                    state: isOpenEmpDropDown,
                  }}
                  handleLaeveManagement={{
                    func: handleOpenLeaveManagement,
                    state: isOpenLeaveManagement,
                  }}
                  handleConfigurations={{
                    func: handleOpenConfigurations,
                    state: isOpenConfigurations,
                  }}
                  handlePayRoll={{
                    func: handleOpenPayRoll,
                    state: isOpenPayRroll,
                  }}
                  handleFinance={{
                    func: handleOpenFinance,
                    state: isOpenFinance,
                  }}
                  handleHelpDesk={{
                    func: handleHelpDesk,
                    state: isOpenHelpdesk,
                  }}
                ></AdminSideBar>
              )}

            {loginUser !== null &&
              loginUser.RoleName !== "Admin" &&
              changedSideBar === null && (
                <EmployeeSideBar
                  loginUser={loginUser}
                  handleLeave={{
                    func:handleOpenLeave,
                    state:isOpenLeaveDropDown,
                  }}
                  handleProject={{
                    func: handleOpenProject,
                    state: isOpenProjectsDropDown,
                  }}
                  handleHelpDesk={{
                    func: handleOpenHelpDesk,
                    state: isOpenHelpdesk,
                  }}
                  activeSideBar={activeSideBar}
                  toggle={toggle}
                ></EmployeeSideBar>
              )}
          </Fragment>
        ) : (
          changedSideBar
        )}
      </nav>
    </Fragment>
  );
}

const mapStateToProps = (state) => ({
  loginUser: state.loginAuthReducer,
});

export default withRouter(connect(mapStateToProps, { checkLogin })(SideBar));
